'use strict';

/* globals RELATIVE_PATH, $ */

require([
	RELATIVE_PATH + '/plugins/nodebb-plugin-courses/static/vendor/vue.js',
], function (Vue) {
	Vue.component('course-start', {
		props: ['initData', 'trainers'],
		data: function () {
			return {
				chapters: this.initData.chapters,
			};
		},
		mounted: function () {
			this.$nextTick(function () {
				this.renderVideo();
			});
		},
		methods: {
			renderVideo: function () {
				$('.trainer-video').customVideo();
			},
		},
		template:
            '<div>' +
                '<ul :class="[trainers.length === 1 ? \'single-trainer\' : \'\', \'nav nav-tabs\']" role="tablist">' +
                    '<li v-for="(trainer, index) in trainers" role="presentation" :class="[index === 0 ? \'active\' : \'\', \'trainer-tab\']">' +
                        '<a :href="\'#trainer\' + trainer.order" :aria-controls="\'trainer\' + trainer.order" role="tab" data-toggle="tab">' +
							'<div class="trainer-img-circle" :style="{ backgroundImage: \'url(\' + trainer.image + \')\' }"></div>' +
                            '{{trainer.name}}' +
                        '</a>' +
                    '</li>' +
                '</ul>' +
                '<div class="tab-content">' +
                    '<div v-for="(trainer, index) in trainers" role="tabpanel" class="tab-pane" :class="{ active: index === 0}" :id="\'trainer\' + trainer.order">' +
                        '<p style="padding: 15px" v-html="trainer.description"></p>' +
                        '<div v-if="trainer.video" class="trainer-video" :data-video-url="trainer.video" :data-video-thumbnail="trainer.videoThumbnail">' +
                    '</div>' +
                '</div>' +
            '</div>',
	});
});
